module.exports = __webpack_public_path__ + "img/MT.dac11acf.svg";